// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--JrUqa","anchor-next":"a10a3f92e9--anchor-next--K_ovW","anchor-icon":"a10a3f92e9--anchor-icon--n2A_O"};